import { render, staticRenderFns } from "./rooms-slider.vue?vue&type=template&id=78a6db74&"
import script from "./rooms-slider.vue?vue&type=script&lang=js&"
export * from "./rooms-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports